import defaultConfig from './default'
import prodConfig from './prod'
import testConfig from './test'

const ENV = process.env.REACT_APP_ENV

const config = (() => {
  switch (ENV) {
    case 'online':
      return { ENV, ...defaultConfig, ...prodConfig }
    default:
      return { ENV, ...defaultConfig, ...testConfig }
  }
})()

export default config
